import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './UploadTrack.css';
import UploadTrackState from './UploadTrackState';
import { categories } from '@shared/constants';
import TrackToUpload from './TrackToUpload/TrackToUpload';
import Dropzone from 'react-dropzone';

/**
 * @typedef {Object} UploadTrackProps
 * @property {UploadTrackState} store - The upload track state store
 */

@observer
class UploadTrack extends Component {
  render() {
    let uploadButton = '';
    if (this.props.store.fileList.length > 0) {
      uploadButton = (
        <button onClick={this.props.store.upload}>Upload</button>
      );
    }

    const options = categories.map(category => (
      <option key={category.id} value={category.id}>
        {category.category_name}
      </option>
    ));


    if (this.props.store.success) {
      return (
        <div className={'UploadTrack'}>
          <h2>Success!</h2>
          <div className={'UploadTrack-section'}>
            You've successfully uploaded{' '}
            <a
              href={''}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.searchForUpload();
              }}
            >
              {this.props.store.nextName}
            </a>
          </div>
          <div className={'UploadTrack-section'}>
            <button onClick={this.props.store.reset}>
              Upload another track
            </button>
          </div>
        </div>
      );
    }

    const tracks = this.props.store.fileList.map((track, i) => {
      // eslint-disable-next-line react/no-array-index-key
      return <TrackToUpload store={track} key={i} />;
    });

    return (
      <div className={'UploadTrack'}>
        <h2>Upload tracks</h2>
        <div className={'UploadTrack-section'}>
          <div>
            Choose a category for this upload:
            <select
              value={
                this.props.store.category != null
                  ? this.props.store.category.id
                  : null
              }
              onChange={e => {
                this.props.store.setCategory(
                  categories.filter(c => c.id === e.target.value)[0]
                );
              }}
            >
              {options}
            </select>
          </div>
        </div>
        <Dropzone onDrop={this.props.store.addTrackViaDropzone}>
          {({getRootProps, getInputProps}) => (
            <section className={'DropZone-HitArea'}>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag some mp3 and wav files here, or click to select.</p>
              </div>
            </section>
          )}
        </Dropzone>
        <div className={'UploadTrack-tray'}>
          {tracks}
        </div>
        <div className={'UploadTrack-section'}>
          {uploadButton}
        </div>
      </div>
    );
  }
}

export default UploadTrack;
